import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../../../../core/services/language.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import {
  CheckPaymentResponse,
  CreateOrderPayload,
  EntryResponse,
  OrderDetail,
  TransactionInformation,
} from '../../../../../core/models/payment.model';
import {
  CityParkingAccountTopUp,
  CreateOrderQRTopupPayload,
  CheckPaymentTopupResponse,
  RetCreateOrder,
} from '../../../../../core/models/topUpAccount.model';
import { firstValueFrom } from 'rxjs';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ApiHandlerService } from '../../../../../tools/services/api/handler-api/apiHandler.service';
import { PssWarnComponent } from "../../../../../tools/template/pss/pss-warn/pss-warn.component";
import { PssFailedComponent } from "../../../../../tools/template/pss/pss-failed/pss-failed.component";
import { PssSuccessComponent } from "../../../../../tools/template/pss/pss-success/pss-success.component";
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { CheckboxComponent } from "../../../../../tools/forms/checkbox/checkbox.component";
import { InputComponent } from '../../../../../tools/forms/input/input.component';
import { ApiTopUpService } from '../../../../../core/services/api/Topup/api-topup';
import { ApiPaymentService } from '../../../../../core/services/api/Payment/api-payment';

@Component({
  selector: 'app-top-up-ev-charger',
  imports: [CommonModule, FormsModule, PssLoadingComponent, ToastWarnComponent, ToastFailedComponent, ToastSuccessComponent, PssWarnComponent, InputComponent],
  templateUrl: './top-up-ev-charger.component.html',
  styleUrl: './top-up-ev-charger.component.css'
})
export class TopUpEvChargerComponent implements OnInit {
  currentLang: 'TH' | 'EN' = 'TH';
  paymentSelect: number = 2;

  token: string = '';
  // ---  Account Topup  --- //
  topUpAccount: CityParkingAccountTopUp | null = null;
  /////////////////////////////

  // QR code
  lastTransaction: any;
  qrImageUrl: string = '';
  orderDetail: any[] = [];
  transactionRow: any[] = [];
  figPrice: string = '';
  countdown: number = 180;
  retCreateOrder: RetCreateOrder | null = null;
  statusCheckQr: boolean = false;
  private cleanupReturnListener?: () => void; // ประกาศตัวแปรในคลาสไว้เก็บ
  private intervalId: any;
  ticketNo: string | null = null;
  transactionDetails: EntryResponse | null = null;
  hours: number = 0;
  minutes: number = 0;
  all_paid: number = 0;
  all_fee: number = 0;
  aa_fee_paid: number = 0;
  aa_penalty_paid: number = 0;
  bb_fee_paid: number = 0;
  bb_penalty_paid: number = 0;
  aa_parkingFee: number = 0;
  aa_penaltyFee: number = 0;
  bb_parkingFee: number = 0;
  bb_penaltyFee: number = 0;
  showPakringFee: number = 0;
  showDiscount: number = 0;
  statusPayment: boolean = false;
  statusReceipt: boolean = false;
  statusPenalty: boolean = false;
  statusDiscount: boolean = false;
  statusToken: boolean = false;

  // Price
  total: number = 0;
  isFixedAmount: boolean = false;
  validateNumber: { where: string, result: boolean } = { where: '', result: false };

  demoPayload: any = null

  paymentPolicy: boolean = false

  /* --- style --- */
  modalFixedAmount: boolean = false;
  modalConfirmPayment: boolean = false;
  modalNotice: boolean = false;

  isThaiQR: boolean = false;
  isLoading: boolean = false;


  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''


  uid: string = '';

  constructor(
    private languageService: LanguageService,
    private router: Router,
    private cookieService: CookieService,
    private apiTopUpService: ApiTopUpService,
    private apiPaymentService: ApiPaymentService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private apiHandler: ApiHandlerService
  ) {
    this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    setTimeout(() => {
      this.getTopUpAccount();
    }, 300);
  }

  /* ------------------------------------------ Function ------------------------------------------ */
  /* --- style --- */
  changeToFixedAmount() {
    this.isFixedAmount = !this.isFixedAmount;
    this.modalFixedAmount = !this.modalFixedAmount;
  }
  confirmToFixedAmount() {
    if (this.figPrice) {
      console.log(this.total);
      this.total = parseFloat(this.figPrice);
      this.modalFixedAmount = !this.modalFixedAmount;
    } else {
      this.total = 0;
      // this.toast.warning(
      //   this.currentLang === 'TH'
      //     ? 'กรุณาระบุยอดเงินที่ต้องการเติม'
      //     : 'Please specify the amount to be topped up.'
      // );
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุยอดเงินที่ต้องการเติม'
          : 'Please specify the amount to be topped up.'
      )
    }
  }
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }
  /* --- function --- */
  goBack() {
    this.router.navigate(['/home']);
  }


  getTopUpAccount() {
    this.isLoading = true;
    this.apiHandler.handleApi(
      this.apiTopUpService.getTopUpAccount(this.uid, this.token),
      {
        logLabel: 'TopUp Account',
        success: (res) => (this.topUpAccount = res),
        finally: () => (this.isLoading = false),
        isConsoleLog: true
      }
    );
  }
  /* ---- Navigate ---- */
  goToTarnsition() {
    this.cookieService.set(
      'topupNumber',
      this.topUpAccount?.accountNumber || '',
      { expires: 1 }
    );
    setTimeout(() => {
      this.router.navigate(['/top-up-history-ev-charger']);
    }, 100);
  }

  /* ---- QR code ---- */
  generateTimestamp(suffix: string): string {
    const now = new Date();

    const pad = (n: number, width = 2): string =>
      n.toString().padStart(width, '0');

    const timestamp =
      now.getFullYear().toString() +
      pad(now.getMonth() + 1) +
      pad(now.getDate()) +
      pad(now.getHours()) +
      pad(now.getMinutes()) +
      pad(now.getSeconds()) +
      now.getMilliseconds().toString().padStart(3, '0');
    return timestamp + suffix;
  }

  startCountdown() {
    this.intervalId = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.close();
      }
    }, 1000);
  }
  close() {
    this.isThaiQR = false;
    this.isLoading = false;
    this.statusCheckQr = false;
  }
  payClick() {
    console.log("total : ", this.total);
    console.log("payment : ", this.paymentSelect);
    if (this.paymentSelect === 0) {
      // this.toast.warning(
      //   this.currentLang === 'TH'
      //     ? 'กรุณาเลือกช่องทางการชำระเงิน'
      //     : 'Please select a payment method.'
      // );
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกช่องทางการชำระเงิน'
          : 'Please select a payment method.'
      )
    } else if (this.total <= 0 || isNaN(this.total)) {
      // this.toast.warning(
      //   this.currentLang === 'TH'
      //     ? 'กรุณาระบุจำนวนเงินที่ต้องการเติม'
      //     : 'Please specify the amount to be topped up.'
      // );
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุจำนวนเงินที่ต้องการเติม'
          : 'Please specify the amount to be topped up.'
      )
    } else if (!this.topUpAccount?.accountNumber) {
      // this.toast.error(
      //   this.currentLang === 'TH'
      //     ? 'ไม่พบบัญชีสำหรับเติมเงิน'
      //     : 'No account found for top-up.'
      // );
      this.showError(
        this.currentLang === 'TH'
          ? 'ไม่พบบัญชีสำหรับเติมเงิน'
          : 'No account found for top-up.'
      )
    } else {
      if (this.total > 1000) {
        // this.toast.warning(
        //   this.currentLang === 'TH'
        //     ? 'ไม่สามารถเติงมเงินเกิน 1,000 บาท'
        //     : 'Cannot top up more than 1,000 THB.'
        // );
        this.showWarning(
          this.currentLang === 'TH'
            ? 'ไม่สามารถเติงมเงินเกิน 1,000 บาท'
            : 'Cannot top up more than 1,000 THB.'
        )
      }
      else if (this.total < 10) {
        // this.toast.warning(
        //   this.currentLang === 'TH'
        //     ? 'ไม่สามารถเติงมเงินน้อยกว่า 60 บาท'
        //     : 'Cannot top up less than 60 THB.'
        // );
        this.showWarning(
          this.currentLang === 'TH'
            ? 'ไม่สามารถเติงมเงินน้อยกว่า 10 บาท'
            : 'Cannot top up less than 10 THB.'
        )
      }
      else {
        // this.isLoading = true;
        this.orderDetail = [];
        const siteIdStr = '99';
        const orderId = this.generateTimestamp(siteIdStr || '');
        console.log('Order ID:', orderId); // Debug log
        const payload: CreateOrderQRTopupPayload = {
          topup_number: this.topUpAccount?.accountNumber || '',
          merchant_order_id: orderId,
          amount: this.total,
          fee_type: '2',
          remark: 'citypakring-topup',
          terminal_id: '',
          payment_method: 'native',
        };

        this.demoPayload = payload;

        console.log(JSON.stringify(payload, null, 2));
        if (payload && payload.merchant_order_id && payload.amount > 0) {
          this.modalNotice = true;
          // this.createOrderQR(payload);
        } else {
          console.warn('⚠️ ข้อมูล payload ไม่ครบถ้วน, ไม่ทำการส่ง API');
        }
      }
    }

    // if (this.total > 0) {
    //   this.isLoading = true;
    //   this.orderDetail = [];
    //   const siteIdStr = this.lastTransaction?.site_id?.toString();
    //   const orderId = this.generateTimestamp(siteIdStr || '');
    //   let payload: CreateOrderPayload = {
    //     order_detail: [],
    //   };
    //   // ข้อมูลเตรียมส่ง
    //   this.transactionRow.forEach((item) => {
    //     const paid = this.total;
    //     const paidPenalty = /*parseFloat(item.paid_penalty)*/ 0;
    //     const newOrder: OrderDetail = {
    //       seq: item.seq,
    //       amount: this.total,
    //       merchant_order_id: orderId,
    //       parkingfee: Math.max(
    //         (item.parkingFee ?? 0) - (isNaN(paid) ? 0 : paid),
    //         0
    //       ),
    //       overnight: 0,
    //       lostcard: Math.max(
    //         (item.penaltyFee ?? 0) - (isNaN(paidPenalty) ? 0 : paidPenalty),
    //         0
    //       ),
    //       fee_type: '2',
    //       remark: 'Webpayment',
    //       terminal_id: '',
    //       payment_method: 'native',
    //     };
    //     payload.order_detail.push(newOrder);
    //   });
    //   if (payload && payload.order_detail && payload.order_detail.length > 0) {
    //     this.token = this.cookieService.get('paymentToken');
    //     this.createOrderQR(payload);
    //   } else {
    //     console.warn('⚠️ ไม่มีข้อมูลใน order_detail, ไม่ทำการส่ง API');
    //   }
    // } else {
    //   console.log('No Price !');
    // }
  }

  submitNoticeEvcharger(event: boolean) {
    this.modalNotice = event;

    if (this.demoPayload) {
      // console.log('demoPayload : ', this.demoPayload);
      this.createOrderQR(this.demoPayload);
    }
  }
  closeNoticeEvcharger(event: boolean) {
    this.modalNotice = event;

    this.demoPayload = null;
  }
  handleAmountClicked(amount: number) {
    this.total = amount;
    this.validateNumber = { where: 'total', result: false };
  }


  /* ------------------------------------------- API  ------------------------------------------- */
  async checkPaymentTopup(): Promise<void> {
    console.log('Checking payment status...');
    this.isLoading = true;
    const merchant_ref = this.cookieService.get('merchant_ref');
    console.log('Merchant Ref:', merchant_ref); // Debug log
    if (!merchant_ref) {
      // this.toast.error(
      //   this.currentLang === 'TH' ? 'ไม่สามารถตรวจสอบได้' : 'Unable to verify.'
      // );
      this.showError(
        this.currentLang === 'TH'
          ? 'ไม่สามารถตรวจสอบได้'
          : 'Unable to verify.'
      )
      this.isLoading = false;
      return;
    }
    try {
      const res: CheckPaymentResponse = await firstValueFrom(
        this.apiPaymentService.checkPayment(merchant_ref, this.token)
      );
      if (res && res.payment_status === true) {
        // ✅ เริ่มทำความสะอาดก่อน redirect
        this.isThaiQR = false;
        this.statusCheckQr = true;
        this.cookieService.delete('merchant_ref');
        this.cookieService.delete('paymentToken');

        setTimeout(() => {
          this.getTopUpAccount();
        }, 100);
        // this.toast.success(
        //   this.currentLang === 'TH' ? 'เติมเงินสำเร็จ' : 'Top-up successful.'
        // );
        this.showSuccess(
          this.currentLang === 'TH'
            ? 'เติมเงินสำเร็จ'
            : 'Top-up successful.'
        )
        if (this.cleanupReturnListener) {
          this.cleanupReturnListener();
        }
      } else {
        this.statusCheckQr = true;
        // this.toast.warning(
        //   this.currentLang === 'TH'
        //     ? 'ยังไม่พบการชำระเงิน'
        //     : 'Payment not yet detected.'
        // );
        this.showWarning(
          this.currentLang === 'TH'
            ? 'ยังไม่พบการชำระเงิน'
            : 'Payment not yet detected.'
        )
      }
    } catch (err) {
      console.error('❌', err);
      // this.toast.error(
      //   this.currentLang === 'TH'
      //     ? 'เกิดข้อผิดพลาดระหว่างทำรายการ'
      //     : 'An error occurred during the transaction.'
      // );
      this.showError(
        this.currentLang === 'TH'
          ? 'เกิดข้อผิดพลาดระหว่างทำรายการ'
          : 'An error occurred during the transaction.'
      )
    } finally {
      this.isLoading = false;
    }
  }

  createOrderQR(payload: CreateOrderQRTopupPayload) {
    if (payload) {
      this.isLoading = true;
      this.apiPaymentService.createOrderQR(payload, this.token).subscribe({
        next: (res: RetCreateOrder) => {
          this.isLoading = false;
          console.log('📦 Response create order :', JSON.stringify(res, null, 2));
          this.retCreateOrder = res;
          if (this.retCreateOrder.result) {
            this.isThaiQR = true;
            this.statusCheckQr = false;
            this.cookieService.set(
              'merchant_ref',
              this.retCreateOrder.merchantRef,
              { expires: 1 }
            ); // 1 วัน
            this.qrImageUrl =
              'data:image/png;base64,' + this.retCreateOrder.qrString;
            // this.startCountdown();
          } else {
            this.isThaiQR = false;
            // this.toast.error(
            //   this.currentLang === 'TH'
            //     ? 'ไม่สามารถสร้างรายการจ่ายได้'
            //     : 'Unable to create payment list.'
            // );
            this.showError(
              this.currentLang === 'TH'
                ? 'ไม่สามารถสร้างรายการจ่ายได้'
                : 'Unable to create payment list.'
            )
          }
        },
        error: (err) => {
          this.isLoading = false;
          console.error('❌  ไม่สำเร็จ:', err);
          // this.toast.error(
          //   this.currentLang === 'TH'
          //     ? 'เกิดข้อผิดพลาดระหว่างทำรายการ'
          //     : 'An error occurred during the transaction.'
          // );
          this.showError(
            this.currentLang === 'TH'
              ? 'เกิดข้อผิดพลาดระหว่างทำรายการ'
              : 'An error occurred during the transaction.'
          )
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    } else {
      this.isLoading = false;
      // this.toast.error(
      //   this.currentLang === 'TH'
      //     ? 'เกิดข้อผิดพลาดระหว่างทำรายการ'
      //     : 'An error occurred during the transaction.'
      // );
      this.showError(
        this.currentLang === 'TH'
          ? 'เกิดข้อผิดพลาดระหว่างทำรายการ'
          : 'An error occurred during the transaction.'
      )
    }
  }
  listenPageReturn(): void {
    let runCount = 0;
    const MAX_RUNS = 3;
    let lastChecked = 0;
    const MIN_INTERVAL = 7 * 1000;

    const checkIfReturn = () => {
      const now = Date.now();
      if (now - lastChecked < MIN_INTERVAL) return;
      lastChecked = now;

      if (runCount >= MAX_RUNS) {
        cleanup();
        return;
      }

      const merchant_ref = this.cookieService.get('merchant_ref');
      if (merchant_ref) {
        runCount++;
        console.log(`🔄 กลับมาใช้งานหน้าเว็บ (รอบที่ ${runCount})`);
        setTimeout(() => {
          this.checkPaymentTopup();
        }, 200);

        if (runCount >= MAX_RUNS) {
          cleanup();
        }
      }
    };

    const visibilityHandler = () => {
      if (document.visibilityState === 'visible') {
        checkIfReturn();
      }
    };

    const focusHandler = () => {
      checkIfReturn();
    };

    const cleanup = () => {
      document.removeEventListener('visibilitychange', visibilityHandler);
      window.removeEventListener('focus', focusHandler);
      console.log('🛑 หยุดตรวจสถานะแล้ว');
    };

    this.cleanupReturnListener = cleanup;

    document.addEventListener('visibilitychange', visibilityHandler);
    window.addEventListener('focus', focusHandler);
  }


}
